import { render, staticRenderFns } from "./CalendarEventSidebar.vue?vue&type=template&id=ad36e4e6"
import script from "./CalendarEventSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarEventSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports